import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getSubProjectIncomeRecord } from '../../../redux/actions/subProjectIncomeRecord'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import { values } from 'lodash-es'
import CoordinatorEvaluateCoworkerWidget from '../../../widgets/evaluatesWidgets/coordinatorEvaluateCoworkerWidgets/CoordinatorEvaluateCoworkerWidget'
import { getProjectEvaluation } from '../../../redux/actions/projectEvaluation'

export default function CoordinatorEvaluateCoworker() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subIncomeId = sessionGetItemStr('subIncomeId')
  const projectVersionId = 'A3590B65-BC6C-4913-9871-7D9DD59FA7B5'
  const projectProgressId = 'B7E895C7-32BE-4AF6-BF79-8A5FE6210BB1'
  const evaluationId = '0'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getProjectEvaluation(projectVersionId, projectProgressId, evaluationId)
      setSchema(response)
      console.log('response==>', response)
      // setSchema(mockSchema2.form)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isEvaluates>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isEvaluates>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isEvaluates>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <CoordinatorEvaluateCoworkerWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'สสส. (นักวิชาการ) ประเมินภาคี ',
    subHeader: '',
    disabled: false,
    inputType: 'RADIO',
    form: {
      question: [
        {
          label: '1.ภาคีมีการวิเคราะห์โครงการและพัฒนาข้อเสนอโครงการได้อย่างมีคุณภาพมากน้อยเพียงใด ',
          name: 'question1',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label: '2.ภาคีมีการวางแผนและบริหารโครงการได้เป็นอย่างดี บรรลุตามเป้าหมายมากน้อยเพียงใด',
          name: 'question2',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '3.ภาคีมีการนำนวัตกรรมมาประยุกต์ใช้ในการดำเนินโครงการ เพื่อก่อให้เกิดการทำงานที่มีประสิทธิภาพ ลดขั้นตอนการทำงาน และเพิ่มคุณค่าให้กับผู้มีส่วนได้ส่วนเสียในโครงการได้มากน้อยเพียงใด',
          name: 'question3',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '4.ภาคีมีการเลือกกลุ่มเป้าหมาย/ ผู้มีส่วนได้ส่วนเสีย (Stakeholder) เข้าร่วมในโครงการ ได้มีความน่าเชื่อถือและสมเหตุสมผลมากน้อยเพียงใด',
          name: 'question4',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'เลือกจากเป้าหมายของโครงการ',
              value: '1',
            },
            {
              disabled: false,
              label: 'เลือกจากคำแนะนำของ สสส.',
              value: '2',
            },
            {
              disabled: false,
              label: 'เลือกจากคำแนะนำของผู้บังคับบัญชา',
              value: '3',
            },
            {
              disabled: false,
              label: 'เลือกจากคำแนะนำของคนใกล้ตัว',
              value: '4',
            },
            {
              disabled: false,
              label: 'เลือกจากคนใกล้ตัว',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '5.ภาคีมีการวัดและติดตามประเมินผลสำเร็จโครงการ เพื่อพัฒนายกระดับงานอย่างต่อเนื่องมากน้อยเพียงใด',
          name: 'question5',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '6.ภาคีสามารถปฏิบัติตามกฎระเบียบที่เกี่ยวข้องกับการบริหารจัดการโครงการของ สสส. มากน้อยเพียงใด',
          name: 'question6',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label: '7.ผลลัพธ์หรือผลผลิตของโครงการมีความสอดคล้องกับเป้าหมายของโครงการ มากน้อยเพียงใด',
          name: 'question7',
          value: '',
          disabled: false,
          inputType: 'RADIO',
          options: [
            {
              disabled: false,
              label: 'มากที่สุด',
              value: '1',
            },
            {
              disabled: false,
              label: 'ค่อนข้างมาก',
              value: '2',
            },
            {
              disabled: false,
              label: 'ไม่แน่ใจ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ค่อนข้างน้อย',
              value: '4',
            },
            {
              disabled: false,
              label: 'น้อยที่สุด',
              value: '5',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '8.ท่านมีความส่วนร่วมในทุกกิจกรรมของโครงการมากน้อยเพียงใด (สามารถเลือกได้มากกว่า 1 ข้อ)',
          name: 'question8',
          value: null, //req. value type array
          disabled: false,
          inputType: 'CHECKBOX',
          options: [
            {
              disabled: false,
              label: 'ถอดบทเรียน',
              value: '1',
            },
            {
              disabled: false,
              label: 'ร่วมคิดและวางแผน',
              value: '2',
            },
            {
              disabled: false,
              label: 'ร่วมดำเนินการ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ร่วมประเมิน',
              value: '4',
            },
          ],
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
        },
        {
          label:
            '9.ท่านคิดว่าเมื่อเทียบผลผลิตกับงบประมาณของโครงการแล้ว ผลผลิตของโครงการมีความคุ้มค่าคิดเป็นร้อยละเท่าใดของงบประมาณ (สามารถตอบเกิน 100% ได้)',
          name: 'question9',
          value: '',
          disabled: false,
          inputType: 'INPUTNUMBER',
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
        },
      ],
    },
  },
}

const mockSchema2 = {
  affectedRows: 5,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  header: 'การประเมินโดยนักวิชาการ',
  subHeader: '',
  disabled: false,
  form: {
    header: 'การประเมินโดยนักวิชาการ',
    evaluations: [
      {
        code: 'CE1',
        name: 'สสส. (นักวิชาการ) ประเมินภาคี ด้านคุณภาพการบริหารจัดการโครงการ',
        questions: [
          {
            label:
              '1.ภาคีมีการวิเคราะห์โครงการและพัฒนาข้อเสนอโครงการได้อย่างมีคุณภาพมากน้อยเพียงใด ',
            name: 'question1',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label: '2.ภาคีมีการวางแผนและบริหารโครงการได้เป็นอย่างดี บรรลุตามเป้าหมายมากน้อยเพียงใด',
            name: 'question2',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '3.ภาคีมีการนำนวัตกรรมมาประยุกต์ใช้ในการดำเนินโครงการ เพื่อก่อให้เกิดการทำงานที่มีประสิทธิภาพ ลดขั้นตอนการทำงาน และเพิ่มคุณค่าให้กับผู้มีส่วนได้ส่วนเสียในโครงการได้มากน้อยเพียงใด',
            name: 'question3',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '4.ภาคีมีการเลือกกลุ่มเป้าหมาย/ ผู้มีส่วนได้ส่วนเสีย (Stakeholder) เข้าร่วมในโครงการ ได้มีความน่าเชื่อถือและสมเหตุสมผลมากน้อยเพียงใด',
            name: 'question4',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'เลือกจากเป้าหมายของโครงการ',
                value: '1',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของ สสส.',
                value: '2',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของผู้บังคับบัญชา',
                value: '3',
              },
              {
                disabled: false,
                label: 'เลือกจากคำแนะนำของคนใกล้ตัว',
                value: '4',
              },
              {
                disabled: false,
                label: 'เลือกจากคนใกล้ตัว',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '5.ภาคีมีการวัดและติดตามประเมินผลสำเร็จโครงการ เพื่อพัฒนายกระดับงานอย่างต่อเนื่องมากน้อยเพียงใด',
            name: 'question5',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '6.ภาคีสามารถปฏิบัติตามกฎระเบียบที่เกี่ยวข้องกับการบริหารจัดการโครงการของ สสส. มากน้อยเพียงใด',
            name: 'question6',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '7.ผลลัพธ์หรือผลผลิตของโครงการมีความสอดคล้องกับเป้าหมายของโครงการ มากน้อยเพียงใด',
            name: 'question7',
            value: '',
            disabled: false,
            inputType: 'RADIO',
            options: [
              {
                disabled: false,
                label: 'มากที่สุด',
                value: '1',
              },
              {
                disabled: false,
                label: 'ค่อนข้างมาก',
                value: '2',
              },
              {
                disabled: false,
                label: 'ไม่แน่ใจ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ค่อนข้างน้อย',
                value: '4',
              },
              {
                disabled: false,
                label: 'น้อยที่สุด',
                value: '5',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '8.ท่านมีความส่วนร่วมในทุกกิจกรรมของโครงการมากน้อยเพียงใด (สามารถเลือกได้มากกว่า 1 ข้อ)',
            name: 'question8',
            value: null, //req. value type array
            disabled: false,
            inputType: 'CHECKBOX',
            options: [
              {
                disabled: false,
                label: 'ถอดบทเรียน',
                value: '1',
              },
              {
                disabled: false,
                label: 'ร่วมคิดและวางแผน',
                value: '2',
              },
              {
                disabled: false,
                label: 'ร่วมดำเนินการ',
                value: '3',
              },
              {
                disabled: false,
                label: 'ร่วมประเมิน',
                value: '4',
              },
            ],
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาระบุคำตอบ' }],
          },
          {
            label:
              '9.ท่านคิดว่าเมื่อเทียบผลผลิตกับงบประมาณของโครงการแล้ว ผลผลิตของโครงการมีความคุ้มค่าคิดเป็นร้อยละเท่าใดของงบประมาณ (สามารถตอบเกิน 100% ได้)',
            name: 'question9',
            value: '',
            disabled: false,
            inputType: 'INPUTNUMBER',
            validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกข้อมูล' }],
          },
        ],
      },
    ],
  },
}
